class Tower {
  constructor(towerCounter, towersArray, color, selectedOptions, prices) {
    this.towersArray = towersArray;
    this.towerCounter = towerCounter;
    this.tower = document.querySelector(`#t${towerCounter}`);
    this.tower.querySelector(".mc-tower-label").innerText = "Tower    " + towerCounter;
    this.toggleIcon = this.tower.querySelector(".mc-collapse-state");
    this.toggleSpace = this.tower.querySelector(".mc-collapse-tower-wrapper");
    this.settingsWrapper = this.tower.querySelector(".mc-tower-properties");
    this.settings = this.tower.querySelectorAll(".mc-setting");
    this.settingToggles = [];
    this.trashIcon = this.tower.querySelector(".mc-trash-icon");
    this.price = 0;
    this.hasDoors = 0;
    this.pricesArray = prices;
    if (towerCounter == 1) {
      this._totalPrice = this.createObservableVariable();
      this._totalDoors = this.createObservableVariable();
      this._hasClosedDoors = this.createObservableVariable();
      // this._hasOpenDoors = this.createObservableVariable();
    }
    this.variants = [];
    this.color = color;
    this.selectedOptions = selectedOptions;
    this.width = new WidthSetting(this.settings[0], this);
    // this.width = new WidthSetting(this.settings[0], this);
    this.topOptions = new TopSetting(this.settings[1], towerCounter, this);
    this.bottomOptions = new BottomSetting(this.settings[2], towerCounter, this);
    this.doorOptions = new DoorSetting(this.settings[3], towerCounter, this);
    this.shelfHangingVariant = {};
    this.shelfHangingVariantPrice = 0;
    this.initTower();
  }

  updateOptionsToWidth(width) {
    this.totalPrice -= this.shelfHangingVariantPrice;
    this.variants.pop();
    this.variants.push(
      this.shelfHangingVariant.types.find(t => {
        return t.description.startsWith(width);
      })
    );
    this.shelfHangingVariantPrice = this.variants[1].price;
    this.totalPrice += this.shelfHangingVariantPrice;
  }

  get totalPrice() {
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    return target._totalPrice.value;
  }

  set totalPrice(value) {
    console.log("set total price", value);
    if (value >= 0) {
      document.isChanged = true;
      let target = this.towerCounter === 1 ? this : this.towersArray[0];
      target._totalPrice.value = value;
      // DOM manipulations
      let checkoutTotal = document.querySelectorAll(".mc-checkout-total");

      checkoutTotal.forEach(ct => {
        ct.innerText = `$${(value / 100).toFixed(2)}`;
      });

      const checkoutBtnTexts = document.querySelectorAll(".mc-checkout-btn-text");
      checkoutBtnTexts.forEach(checkoutBtnText => {
        const totalSpan = checkoutBtnText.querySelector("span");
        if (totalSpan) {
          totalSpan.innerText = `$${(value / 100).toFixed(2)}`;
        }
      });

      let draftTotalAmountText = document.getElementById("draft-total-amount");
      if (draftTotalAmountText) {
        draftTotalAmountText.innerText = (value / 100).toFixed(2);
      }
      let discountedTotalDiv = document.querySelector(".discounted-price .discounted-value");
      if (discountedTotalDiv) {
        discountedTotalDiv.textContent = (value / 100).toFixed(2);
      }

      let breadFinanceText = document.querySelector("#breadFinanceText");
      if (breadFinanceText) {
        breadFinanceText.innerText = calculateMonthlyPayment(value / 100).toFixed(2);
      }
      discountPercent && updateDiscount();
    }
  }

  get totalDoors() {
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    return target._totalDoors.value;
  }

  set totalDoors(value) {
    console.log("set totaldoors", value);
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    target._totalDoors.value = value;
  }

  get hasClosedDoors() {
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    return target._hasClosedDoors.value;
  }

  set hasClosedDoors(value) {
    console.log("set hasClosedDoors", value, getToggleDoorsState());
    let target = this.towerCounter === 1 ? this : this.towersArray[0];
    target._hasClosedDoors.value = value;
    if (value == 0 && getToggleDoorsState() == "Open Doors") {
      toggleDoors();
    } else {
      if (this.towersArray.length) {
        let hasOpenDoors = this.towersArray.find(t => {
          t.doorOptions.doorState === "open";
        });
        if (!hasOpenDoors && getToggleDoorsState() == "Close Doors") {
          toggleDoors();
        }
      }
    }
  }

  initTower() {
    this.initPrice();
    this.addTowerToCanvas();
    this.initToggleIcon();
    this.initTrashIcon();
    this.initSettingToggles();
    this.setDefaultObjects();
  }
  initPrice() {
    const price = this.pricesArray.find(priceItem => {
      return priceItem.title == "milano-side-panels";
    });
    if (this.towerCounter == 1) {
      this.variants[0] = price.types.find(t => {
        return t.description.startsWith("Finished");
      });
      this.price = this.variants[0].price;
    } else {
      this.variants[0] = price.types.find(t => {
        return t.description.startsWith("Shared");
      });
      this.price = this.variants[0].price;
    }
    this.shelfHangingVariant = this.pricesArray.find(priceItem => {
      return priceItem.title === "milano-fixed-shelf-rod-pack";
    });
    this.variants.push(this.shelfHangingVariant.types[0]);
    this.shelfHangingVariantPrice = this.shelfHangingVariant.types[0].price;
    this.price += this.shelfHangingVariantPrice;
    this.totalPrice += this.price;
  }

  delete() {
    this.totalPrice -= this.price;
  }

  createObservableVariable() {
    let _value = 0;

    return {
      get value() {
        return _value;
      },
      set value(newValue) {
        _value = newValue;
      },
    };
  }
  setDefaultObjects() {
    if (this.selectedOptions) {
      this.width.selectWidth(this.selectedOptions.width);
      this.topOptions.selectOption(this.selectedOptions.topOption);
      this.bottomOptions.isDefaultValue = false;
      this.bottomOptions.selectOption(this.selectedOptions.bottomOption);
      this.doorOptions.selectOption(this.selectedOptions.doorOption);
    } else {
      this.topOptions.addOptionToCanvas();
      this.bottomOptions.addOptionToCanvas();
    }
    console.log("towersArray", this.towersArray, this.towersArray.length);
  }
  addTowerToCanvas() {
    if (this.towersArray.length < 1) {
      document.App.addBigWardrobeToScene(
        "Wardrobe_D22_ND_W30",
        document.App.positions["Wardrobe_D22_W30"]
      );
      // const customPosition =    {
      //       x: 0,
      //       y: 0,
      //       z: 0
      //   }
      //   document.App.addBigWardrobeToScene('Wardrobe_D22_ND_W30', [customPosition]);
      this.initColorSetting();
    } else {
      this.towersArray[this.towerCounter - 2].width.widthFixed = true;
      // this.towersArray[this.towerCounter - 2].width.disable();
      document.App.addBigAdditionalCabinetF(
        "Wardrobe_D22_ND_W30",
        document.App.positions["Wardrobe_D22_ND_W30"]
      );
      document.CabinetVars.SelectedIndex = this.towerCounter - 1;
      this.towersArray[this.towersArray.length - 1].doorOptions.closeDoors();
    }
    // document.App.addObjectToSelectedCabinet('One_Adjustable_Shelves_D22_W30', 5);
    // document.App.addObjectToSelectedCabinet('Hanger_W30', 0);
    // document.App.addObjectToSelectedCabinet('Two_Drawers_D22_W30', 0);
    // document.App.addObjectToSelectedCabinet('Two_Drawers_D22_W30', 1);
    // isChanged = true;
  }
  initSettingToggles() {
    this.settings.forEach(setting => {
      this.settingToggles.push(new SettingToggle(setting, this.settingToggles, this));
    });
  }
  minimizeTower() {
    this.toggleIcon.classList.remove("mc-collapse-state-expanded");
    this.toggleIcon.classList.add("mc-collapse-state-minimized");
    this.tower.classList.remove("mc-tower-expanded");
    this.tower.classList.add("mc-tower-minimized");
    this.settingsWrapper.classList.remove("mc-tower-properties-expanded");
    this.settingsWrapper.classList.add("mc-tower-properties-minimized");
  }
  expandTower() {
    document.CabinetVars.SelectedIndex = this.towerCounter - 1;
    this.toggleIcon.classList.remove("mc-collapse-state-minimized");
    this.toggleIcon.classList.add("mc-collapse-state-expanded");
    this.tower.classList.remove("mc-tower-minimized");
    this.tower.classList.add("mc-tower-expanded");
    this.settingsWrapper.classList.remove("mc-tower-properties-minimized");
    this.settingsWrapper.classList.add("mc-tower-properties-expanded");
  }
  toggleTower(_this) {
    _this = _this || this;
    if (_this.toggleIcon.classList.contains("mc-collapse-state-expanded")) {
      _this.minimizeTower();
    } else {
      this.towersArray.forEach(tower => {
        if (tower !== this) {
          tower.minimizeTower();
        }
      });
      this.expandTower();
    }
  }
  initToggleIcon() {
    let _this = this;
    this.toggleSpace.addEventListener("click", () => this.toggleTower(_this));
  }

  initTrashIcon() {
    this.trashIcon.addEventListener("click", () => removeTower(this.towerCounter - 1));
  }

  initColorSetting() {
    let colorsWrapper = document.querySelector(".mc-color-options");
    let colors = colorsWrapper.querySelectorAll("input");
    colors.forEach(color => {
      color.addEventListener("click", () => {
        this.setColor();
      });
    });
    if (this.color) {
      colors.forEach(color => {
        if (color.getAttribute("value") == this.color) {
          color.checked = true;
        }
      });
      this.setColor();
    }
  }
  setColor() {
    const value = document.querySelector(`input[name="color"]:checked`).value;
    let selectedColor = document.querySelector(".mc-color-selected");
    document.isChanged = selectedColor.innerText == value ? document.isChanged : true;
    selectedColor.innerText = value;
    switch (value) {
      case "NATURAL OAK":
        document.App.material.color.set(0xe5d9bd);
        document.App.materialNoAO.color.set(0xe5d9bd);
        break;
      case "GREY":
        document.App.material.color.set(0x808080);
        document.App.materialNoAO.color.set(0x808080);
        break;
      case "WHITE" || "white":
        document.App.material.color.set(0xffffff);
        document.App.materialNoAO.color.set(0xffffff);
    }
  }
}
class DoorSetting {
  constructor(doorSetting, towerCounter, tower) {
    this.doorSetting = doorSetting;
    this.towerCounter = towerCounter;
    this.tower = tower;
    this.options = doorSetting.querySelectorAll(".mc-radio-item");
    this.selectedValueElement = doorSetting.querySelector(".mc-selected-setting");
    this.selectedValue = "none";
    this.price = 0;
    this.doorPrices = [];
    this.variants = [];
    this.doorState = null;
    this.initDoorSetting();
    this.updateOptionsToWidth("30");
    this.initPrice();
  }
  initPrice() {
    this.doorPrices = this.tower.pricesArray.find(priceItem => {
      return priceItem.title == "milano-door-1";
    }).types;
  }
  openDoors() {
    document.App.openLeftDoor(document.App.cabinets[document.CabinetVars.SelectedIndex]);
    document.App.openRightDoor(document.App.cabinets[document.CabinetVars.SelectedIndex]);
    if (this.doorState !== "open") {
      this.doorState = "open";
      this.tower.hasClosedDoors -= 1;
    }
    // this.tower.hasOpenDoors += 1;
    // document.App.openLeftDoor(document.App.cabinets[this.towerCounter - 1]);
    // document.App.openRightDoor(document.App.cabinets[this.towerCounter - 1]);
  }
  closeDoors() {
    document.App.closeLeftDoor(document.App.cabinets[document.CabinetVars.SelectedIndex]);
    document.App.closeRightDoor(document.App.cabinets[document.CabinetVars.SelectedIndex]);
    if (this.doorState !== "closed") {
      this.doorState = "closed";
      this.tower.hasClosedDoors += 1;
    }
  }
  initDoorSetting() {
    this.options.forEach(option => {
      option.querySelector("input").setAttribute("name", `door-${this.towerCounter}`);
      const optionId = option.querySelector("input").getAttribute("id");
      option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
      option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
      option.addEventListener("click", () => this.addOptionToCanvas());
    });
  }
  updateOptionsToWidth(width) {
    const width15options = ["Slab Door", "Mirror Door", "Shaker Door"];
    this.options.forEach(option => {
      if (option.querySelector("label").innerText != "None") {
        if (width == "15") {
          if (!width15options.includes(option.querySelector("label").innerText)) {
            option.style.display = "none";
          } else {
            option.style.display = "flex";
          }
        }
        if (width == "30") {
          if (!width15options.includes(option.querySelector("label").innerText)) {
            option.style.display = "flex";
          } else {
            option.style.display = "none";
          }
        }
      }
    });
    // if (width == 'W15') {
    //     this.options.forEach(option => {
    //         const value = option.querySelector('input').getAttribute('value');
    //         if (value != 'None') {
    //             option.querySelector('input').setAttribute('value', value.slice(0, -1));
    //             option.querySelector('label').innerText = value.slice(0, -1);
    //         }
    //     })
    // }
    // else {
    //     this.options.forEach(option => {
    //         const value = option.querySelector('input').getAttribute('value');
    //         if (value != 'None') {
    //             option.querySelector('input').setAttribute('value', `${value}s`);
    //             option.querySelector('label').innerText = value + 's';
    //         }
    //     })
    // }
  }
  addOptionToCanvas() {
    const selectedOption = this.doorSetting.querySelector(
      `input[name="door-${this.towerCounter}"]:checked`
    );
    const value = selectedOption.value;
    const displayValue = selectedOption.getAttribute("displayValue");
    this.selectedValueElement.innerText = displayValue;
    this.selectedValue = value;
    const objects = {
      "slab-doors": "One_Flat_Door",
      "slab-door": "One_Flat_Door_W15",
      "mirror-doors": "One_Mirror_Door",
      "mirror-door": "One_Mirror_Door_W15",
      "shaker-doors": "One_Shaker_Door",
      "shaker-door": "One_Shaker_Door_W15",
    };
    this.tower.totalPrice -= this.price;
    this.tower.totalDoors -= this.tower.hasDoors;
    this.price = 0;
    this.variants = [];
    document.CabinetVars.SelectedIndex = this.tower.towerCounter - 1;
    if (value != "none") {
      this.tower.hasDoors = 1;
      if (this.doorState !== "closed") {
        this.doorState = "closed";
        this.tower.hasClosedDoors += 1;
      }
      this.variants.push(
        this.doorPrices.find(p => {
          return p.description.toLowerCase() == value.substring(0, value.indexOf("-"));
        })
      );
      const price = this.variants[0].price;
      document.CabinetVars.SelectedIndex = this.tower.towerCounter - 1;
      if (this.tower.width.selectedValue == "30") {
        document.App.addObjectToSelectedCabinet(`${objects[value]}_Right`, 0);
        document.App.addObjectToSelectedCabinet(`${objects[value]}_Left`, 0);

        if (!value.startsWith("mirror")) {
          document.App.addObjectToSelectedCabinet(`RightHandle_W30`, 0);
          document.App.addObjectToSelectedCabinet(`LeftHandle_W30`, 0);
        } else {
          document.App.addObjectToSelectedCabinet(`Mirror_Door_Handle_L`, 0);
          document.App.addObjectToSelectedCabinet(`Mirror_Door_Handle_R`, 0);
        }
        this.price = price * 2;
        this.variants.push(this.variants[0]); //add second door for 30''
      } else {
        document.App.addObjectToSelectedCabinet(`${objects[value]}`, 0);
        if (!value.startsWith("mirror")) {
          document.App.addObjectToSelectedCabinet(`Handle_W15`, 0);
        } else {
          document.App.addObjectToSelectedCabinet(`Mirror_Door_Handle_W15`, 0);
        }
        this.price = price;
      }
    } else {
      document.App.removeObjectFromSelectedCabinet([
        document.App.spaceId.LEFTDOOR,
        document.App.spaceId.RIGHTDOOR,
      ]);
      this.tower.hasDoors = 0;
      if (this.doorState == "closed") {
        this.tower.hasClosedDoors -= 1;
        this.doorState = null;
      }
    }
    this.tower.totalPrice += this.price;
    this.tower.totalDoors += this.tower.hasDoors;
    disableEnableAction("doors", !this.tower.totalDoors);
  }
  selectOption(opt) {
    this.options.forEach(option => {
      const input = option.querySelector("input");
      const value = input.getAttribute("value");
      if (value == opt) {
        input.checked = true;
      }
    });
    this.addOptionToCanvas();
  }
}
class BottomSetting {
  constructor(bottomSetting, towerCounter, tower) {
    this.bottomSetting = bottomSetting;
    this.towerCounter = towerCounter;
    this.tower = tower;
    this.options = bottomSetting.querySelectorAll(".mc-radio-item");
    this.selectedValueElement = bottomSetting.querySelector(".mc-selected-setting");
    this.selectedValue = "four-drawers";
    this.isDefaultValue = true;
    this.price = 0;
    this.variants = [];
    this.initBottomSetting();
  }
  initBottomSetting() {
    this.options.forEach(option => {
      option.querySelector("input").setAttribute("name", `bottom-${this.towerCounter}`);
      const optionId = option.querySelector("input").getAttribute("id");
      option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
      option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
      option.addEventListener("click", () => this.addOptionToCanvas("event"));
      // option.addEventListener('click', () => this.updateSelectedValue());
    });
  }

  addOptionToCanvas(event) {
    if (event == "event") {
      this.isDefaultValue = false;
    }
    const selectedOption = this.bottomSetting.querySelector(
      `input[name="bottom-${this.towerCounter}"]:checked`
    );
    const value = selectedOption.value;
    const displayValue = selectedOption.getAttribute("displayValue");
    this.selectedValueElement.innerText = displayValue;
    this.selectedValue = value;
    // const value = this.querySelector('input').getAttribute('value');
    const objects = {
      "chest-of-drawers": {
        width30: ["Chest_of_Drawers"],
        width15: [],
        position: [0],
        variants: ["milano-chest-of-drawers"],
      },
      "four-drawers": {
        width30: ["Two_Drawers_D22_W30", "Two_Drawers_D22_W30"],
        width15: [],
        position: [0, 1],
        variants: ["milano-drawer-pack-2", "milano-drawer-pack-2"],
      },
      "two-shelves": {
        width30: ["One_Adjustable_Shelves_D22_W30", "One_Adjustable_Shelves_D22_W30"],
        width15: ["One_Adjustable_Shelves_D22_W15", "One_Adjustable_Shelves_D22_W15"],
        position: [0, 1],
        variants: ["milano-adjustable-shelf-pack-2"],
      },
      "shoe-shelves": {
        width30: ["Two_Shoe_Shelves_D22_W30"],
        width15: [],
        position: [0],
        variants: ["milano-shoe-shelf-pack-2"],
      },
      hanging: {
        width30: ["Hanger_W30"],
        width15: ["Hanger_W15"],
        position: [1],
        variants: [],
      },
      "cubbies-over-chest-of-drawers": {
        width30: ["Cubby_Over_Chest", "Chest_of_Drawers"],
        width15: [],
        position: [0, 0],
        variants: ["milano-cubby-over-chest", "milano-chest-of-drawers"],
      },
      "two-drawers-and-shelf": {
        width30: ["One_Adjustable_Shelves_D22_W30", "Two_Drawers_D22_W30"],
        width15: [],
        position: [0, 1],
        variants: ["milano-adjustable-shelf-pack-2", "milano-drawer-pack-2"],
      },
    };
    // if (value == 'hanging') {
    //   if (!this.tower.hasHanging.bottom) {
    //     this.tower.hasHanging.bottom = true;
    //     this.tower.calculateHangingPrice('bottom');
    //   }
    // }
    // else {
    //   if (this.tower.hasHanging.bottom) {
    //     this.tower.hasHanging.bottom = false;
    //     this.tower.calculateHangingPrice();
    //   }
    // }
    this.tower.totalPrice -= this.price;
    this.price = 0;
    this.variants = [];
    if (value != "none") {
      document.App.removeObjectFromSelectedCabinet([document.App.spaceId.THREE]);
      let width = "width30";
      if (this.tower.width.selectedValue == "15") {
        width = "width15";
      }
      objects[value][width].forEach((object, index) => {
        document.App.addObjectToSelectedCabinet(object, objects[value].position[index]);
      });
      objects[value].variants.forEach(v => {
        this.variants.push(
          this.tower.pricesArray
            .find(p => {
              return p.title == v;
            })
            ?.types.find(t => {
              return t.description.startsWith(width.substring("width".length));
            })
        );
        this.price += this.variants[this.variants.length - 1]?.price || 0;
      });
      if (this.tower.topOptions.selectedValue == "tall-hanging") {
        this.tower.topOptions.selectOption("short-hanging");
      }
    } else {
      document.App.removeObjectFromSelectedCabinet([
        document.App.spaceId.THREE,
        document.App.spaceId.TWO,
        document.App.spaceId.ONE,
        document.App.spaceId.ZERO,
      ]);
      if (this.tower.topOptions.selectedValue == "tall-hanging") {
        document.App.addObjectToSelectedCabinet(`Hanger_W${this.tower.width.selectedValue}`, 2);
      }
    }
    this.tower.totalPrice += this.price;
  }
  selectOption(opt) {
    const width15options = ["none", "hanging", "two-shelves"];
    if (
      this.tower.width.selectedValue == "15" &&
      !this.isDefaultValue &&
      !width15options.includes(opt)
    ) {
      //when swapping for small cabinet if opt invalid set to none
      opt = "none";
    }
    if (this.isDefaultValue && opt != "none") {
      if (this.tower.width.selectedValue == "15") {
        opt = "two-shelves";
      } else {
        opt = "four-drawers";
      }
    }
    this.options.forEach(option => {
      const input = option.querySelector("input");
      const value = input.getAttribute("value");
      // let inputValue = input.value;
      if (value == opt) {
        input.checked = true;
      }
    });
    this.addOptionToCanvas();
  }
  updateOptionsToWidth(width) {
    const width15options = ["None", "Hanging", "2 Shelves"];
    this.options.forEach(option => {
      if (!width15options.includes(option.querySelector("label").innerText)) {
        if (width == "15") {
          option.style.display = "none";
        } else {
          option.style.display = "flex";
        }
      }
    });
  }
}
class TopSetting {
  constructor(topSetting, towerCounter, tower) {
    this.topSetting = topSetting;
    this.towerCounter = towerCounter;
    this.tower = tower;
    this.options = topSetting.querySelectorAll(".mc-radio-item");
    this.selectedValueElement = topSetting.querySelector(".mc-selected-setting");
    this.selectedValue = "none";
    this.price = 0;
    this.variants = [];
    this.initTopSetting();
  }
  selectOption(opt) {
    if (this.tower.width.selectedValue == "15" && opt == "cubbies") {
      opt = "none";
    }
    this.options.forEach(option => {
      const input = option.querySelector("input");
      const value = input.getAttribute("value");
      if (value == opt) {
        input.checked = true;
      }
    });
    this.addOptionToCanvas();
  }
  addOptionToCanvas() {
    const objects = {
      none: {
        width30: ["One_Adjustable_Shelves_D22_W30"],
        width15: ["One_Adjustable_Shelves_D22_W15"],
        position: [5],
        variants: [],
      },
      cubbies: {
        width30: ["One_Adjustable_Shelves_D22_W30", "Cubby_Shelves_D22_W30"],
        width15: [],
        position: [5, 0],
        variants: ["milano-cubby-insert"],
      },
      "two-shelves": {
        width30: [
          "One_Adjustable_Shelves_D22_W30",
          "One_Adjustable_Shelves_D22_W30",
          "One_Adjustable_Shelves_D22_W30",
        ],
        width15: [
          "One_Adjustable_Shelves_D22_W15",
          "One_Adjustable_Shelves_D22_W15",
          "One_Adjustable_Shelves_D22_W15",
        ],
        position: [5, 3, 2],
        variants: ["milano-adjustable-shelf-pack-2"],
      },
      "tall-hanging": {
        width30: ["One_Adjustable_Shelves_D22_W30", "Hanger_W30"],
        width15: ["One_Adjustable_Shelves_D22_W15", "Hanger_W15"],
        position: [4, 2],
        variants: [],
      },
      "short-hanging": {
        width30: ["One_Adjustable_Shelves_D22_W30", "Hanger_W30"],
        width15: ["One_Adjustable_Shelves_D22_W15", "Hanger_W15"],
        position: [5, 0],
        variants: [],
      },
    };
    const selectedOption = this.topSetting.querySelector(
      `input[name="top-${this.towerCounter}"]:checked`
    );
    const value = selectedOption.value;
    const displayValue = selectedOption.getAttribute("displayValue");
    // const object = this.topSetting.querySelector(`input[name="top-${this.towerCounter}"]:checked`).getAttribute('object');
    this.selectedValueElement.innerText = displayValue;
    this.selectedValue = value;
    // const width = this.tower.width.selectedValue;
    document.App.removeObjectFromSelectedCabinet([
      document.App.spaceId.SEVEN,
      document.App.spaceId.SIX,
      document.App.spaceId.FIVE,
      document.App.spaceId.FOUR,
    ]);
    if (value == "tall-hanging") {
      this.tower.bottomOptions.isDefaultValue = false;
      document.App.removeObjectFromSelectedCabinet([document.App.spaceId.MIDDLE]);
      this.tower.bottomOptions.selectOption("none");
    }
    let width = "width30";
    if (this.tower.width.selectedValue != "30") {
      width = "width15";
    }
    objects[value][width].forEach((object, index) => {
      document.App.addObjectToSelectedCabinet(object, objects[value].position[index]);
    });

    this.tower.totalPrice -= this.price;
    this.price = 0;
    this.variants = [];
    // if (value == "short-hanging") {
    // 	if (!this.tower.hasHanging.top) {
    // 		this.tower.hasHanging.top = true;
    // 		this.tower.calculateHangingPrice("top");
    // 	}
    // } else {
    // 	if (this.tower.hasHanging.top) {
    // 		this.tower.hasHanging.top = false;
    // 		this.tower.calculateHangingPrice();
    // 	}
    // }
    if (value != "none") {
      objects[value].variants.forEach(v => {
        this.variants.push(
          this.tower.pricesArray
            .find(p => {
              return p.title == v;
            })
            ?.types.find(t => {
              return t.description.startsWith(width.substring("width".length));
            })
        );
        this.price += this.variants[this.variants.length - 1]?.price || 0;
      });
    }
    this.tower.totalPrice += this.price;
  }
  updateOptionsToWidth(width) {
    this.options.forEach(option => {
      if (option.querySelector("label").innerText == "Cubbies") {
        if (width == "15") {
          option.style.display = "none";
        } else {
          option.style.display = "flex";
        }
      }
    });
  }
  initTopSetting() {
    let _this = this;
    this.options.forEach(option => {
      option.querySelector("input").setAttribute("name", `top-${this.towerCounter}`);
      const optionId = option.querySelector("input").getAttribute("id");
      option.querySelector("input").setAttribute("id", `${optionId}-${this.towerCounter}`);
      option.querySelector("label").setAttribute("for", `${optionId}-${this.towerCounter}`);
      option.addEventListener("click", () => this.addOptionToCanvas());
    });
  }
}

class WidthSetting {
  constructor(widthSetting, tower) {
    // constructor(widthSetting, tower) {
    this.tower = tower;
    this.widthOptions = widthSetting.querySelectorAll(".mc-width-option");
    this.width30option = this.widthOptions[0];
    this.width15option = this.widthOptions[1];
    this.selectedValueElement = widthSetting.querySelector(".mc-selected-setting");
    this.selectedValue = "30";
    this.widthFixed = false;
    this.initWidthSetting();
  }

  selectWidth(width) {
    if (this.widthFixed) {
      editWidth(this.tower.towerCounter, width);
    } else {
      console.log("selectwidth", width, this.widthFixed);
      const topOption = this.tower.topOptions.selectedValue;
      const bottomOption = this.tower.bottomOptions.selectedValue;
      let doorOption = this.tower.doorOptions.selectedValue;
      console.log("save options", topOption, bottomOption, doorOption);
      this.tower.topOptions.selectOption("none");
      this.tower.bottomOptions.selectOption("none");
      this.tower.doorOptions.selectOption("none");
      console.log(
        "set options to none",
        this.tower.topOptions.selectedValue,
        this.tower.bottomOptions.selectedValue
      );
      document.App.removeObjectFromSelectedCabinet([document.App.spaceId.MIDDLE]);
      console.log("cleared divider");
      // if (!this.widthFixed) {
      if (width == "30") {
        this.width30option.classList.add("mc-width-active");
        this.width15option.classList.remove("mc-width-active");
        this.selectedValueElement.innerText = this.width30option.innerText;
        this.selectedValue = "30";
        if (this.tower.towerCounter == 1) {
          document.App.addBigWardrobeToScene(
            `Wardrobe_D22_ND_W30`,
            document.App.positions[`Wardrobe_D22_ND_W30`]
          );
        } else {
          document.App.swapLastSmallCabinet();
        }
      } else {
        this.width15option.classList.add("mc-width-active");
        this.width30option.classList.remove("mc-width-active");
        this.selectedValueElement.innerText = this.width15option.innerText;
        this.selectedValue = "15";
        if (this.tower.towerCounter == 1) {
          document.App.addSmallWardrobeToScene(
            `Wardrobe_D22_ND_W15`,
            document.App.positions[`Wardrobe_D22_ND_W15`]
          );
        } else {
          document.App.swapLastBigCabinet();
        }
      }
      // document.App.addObjectToSelectedCabinet(`One_Adjustable_Shelves_D22_${width}`, 5);
      // this.updateDividerToWidth(this.selectedValue);
      console.log("new width", this.selectedValue);
      this.tower.updateOptionsToWidth(this.selectedValue);
      this.tower.topOptions.updateOptionsToWidth(this.selectedValue);
      this.tower.bottomOptions.updateOptionsToWidth(this.selectedValue);
      this.tower.doorOptions.updateOptionsToWidth(this.selectedValue);
      this.tower.bottomOptions.selectOption(bottomOption);
      this.tower.topOptions.selectOption(topOption);
      if (doorOption != "none") {
        if (doorOption.slice(-1) == "s") {
          doorOption = doorOption.slice(0, -1);
        } else {
          doorOption = doorOption + "s";
        }
      }
      this.tower.doorOptions.selectOption(doorOption);
      doorOption != "none" && this.tower.doorOptions.openDoors();
      // }
    }
  }
  // disable() {
  //     this.width30option.classList.remove('mc-width-active');
  //     this.width15option.classList.remove('mc-width-active');
  // }

  initWidthSetting() {
    // if (this.widthFixed) {
    //     this.disable();
    // }
    // else {
    let _this = this;
    this.width30option.addEventListener("click", function selectWidth30() {
      _this.selectWidth("30");
    });
    this.width15option.addEventListener("click", function selectWidth15() {
      _this.selectWidth("15");
    });
    // }
  }
}

class SettingToggle {
  constructor(setting, allSettings, tower) {
    this.allSettings = allSettings;
    this.setting = setting;
    this.tower = tower;
    this.toggleIcon = this.setting.querySelector(".mc-arrow-collapse");
    this.settingLabel = this.setting.querySelector(".mc-setting-label");
    this.settingTitle = this.settingLabel.querySelector(".mc-setting-title").innerText;
    this.settingOptions = setting.querySelector(".mc-setting-options");
    this.options = this.settingOptions.querySelectorAll(".mc-option");
    this.initSettingToggle();
  }
  initSettingToggle() {
    this.initToggleIcon();
  }
  initToggleIcon() {
    let _this = this;
    this.settingLabel.addEventListener("click", () => _this.toggleSetting());
  }
  minimizeSetting() {
    this.toggleIcon.classList.remove("mc-arrow-collapse-expanded");
    this.toggleIcon.classList.add("mc-arrow-collapse-minimized");
    this.settingOptions.classList.remove("mc-setting-options-expanded");
    this.settingOptions.classList.add("mc-setting-options-minimized");
    this.options.forEach(option => {
      option.classList.remove("mc-option-expanded");
      option.classList.add("mc-option-minimized");
    });
  }
  expandSetting() {
    console.log("expand Setting", this.tower.doorOptions.selectedValue, this.settingTitle); //DOOR OPTIONS
    if (this.tower.doorOptions.selectedValue != "none") {
      if (this.settingTitle == "DOOR OPTIONS") {
        this.tower.doorOptions.closeDoors();
      } else {
        this.tower.doorOptions.openDoors();
      }
    }
    this.toggleIcon.classList.remove("mc-arrow-collapse-minimized");
    this.toggleIcon.classList.add("mc-arrow-collapse-expanded");
    this.settingOptions.classList.remove("mc-setting-options-minimized");
    this.settingOptions.classList.add("mc-setting-options-expanded");
    this.options.forEach(option => {
      option.classList.remove("mc-option-minimized");
      option.classList.add("mc-option-expanded");
    });
  }
  toggleSetting() {
    if (this.toggleIcon.classList.contains("mc-arrow-collapse-expanded")) {
      this.minimizeSetting();
    } else {
      this.allSettings.forEach(setting => {
        if (setting !== this) {
          setting.minimizeSetting();
        }
      });
      this.expandSetting();
    }
  }
}
